module.exports = __webpack_public_path__ + "DINNextLTPro-Bold.woff?bdd063c7dcfa364017195fa9c22564fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Bold.woff
// module id = 1416
// module chunks = 0